/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addBundleGroupVirtualArticle } from '../fn/bundle-groups/add-bundle-group-virtual-article';
import { AddBundleGroupVirtualArticle$Params } from '../fn/bundle-groups/add-bundle-group-virtual-article';
import { addBundleGroupVirtualArticleDiscrepancy } from '../fn/bundle-groups/add-bundle-group-virtual-article-discrepancy';
import { AddBundleGroupVirtualArticleDiscrepancy$Params } from '../fn/bundle-groups/add-bundle-group-virtual-article-discrepancy';
import { addBundleGroupVirtualArticleNote } from '../fn/bundle-groups/add-bundle-group-virtual-article-note';
import { AddBundleGroupVirtualArticleNote$Params } from '../fn/bundle-groups/add-bundle-group-virtual-article-note';
import { BundleGroup } from '../models/bundle-group';
import { BundleGroupCheckinFinishResponse } from '../models/bundle-group-checkin-finish-response';
import { BundleGroupCheckinStartResponse } from '../models/bundle-group-checkin-start-response';
import { BundleGroupsArrayResponseV3 } from '../models/bundle-groups-array-response-v-3';
import { checkBundleGroupVirtualArticle } from '../fn/bundle-groups/check-bundle-group-virtual-article';
import { CheckBundleGroupVirtualArticle$Params } from '../fn/bundle-groups/check-bundle-group-virtual-article';
import { checkinBundleGroup } from '../fn/bundle-groups/checkin-bundle-group';
import { CheckinBundleGroup$Params } from '../fn/bundle-groups/checkin-bundle-group';
import { createBundleGroup } from '../fn/bundle-groups/create-bundle-group';
import { CreateBundleGroup$Params } from '../fn/bundle-groups/create-bundle-group';
import { deleteBundleGroup } from '../fn/bundle-groups/delete-bundle-group';
import { DeleteBundleGroup$Params } from '../fn/bundle-groups/delete-bundle-group';
import { deleteBundleGroupVirtualArticleDiscrepancy } from '../fn/bundle-groups/delete-bundle-group-virtual-article-discrepancy';
import { DeleteBundleGroupVirtualArticleDiscrepancy$Params } from '../fn/bundle-groups/delete-bundle-group-virtual-article-discrepancy';
import { editBundleGroupVirtualArticleAttributes } from '../fn/bundle-groups/edit-bundle-group-virtual-article-attributes';
import { EditBundleGroupVirtualArticleAttributes$Params } from '../fn/bundle-groups/edit-bundle-group-virtual-article-attributes';
import { EnrichedVirtualArticle } from '../models/enriched-virtual-article';
import { finishBundleGroupCheckin } from '../fn/bundle-groups/finish-bundle-group-checkin';
import { FinishBundleGroupCheckin$Params } from '../fn/bundle-groups/finish-bundle-group-checkin';
import { getBundleGroup } from '../fn/bundle-groups/get-bundle-group';
import { GetBundleGroup$Params } from '../fn/bundle-groups/get-bundle-group';
import { getBundleGroups } from '../fn/bundle-groups/get-bundle-groups';
import { GetBundleGroups$Params } from '../fn/bundle-groups/get-bundle-groups';
import { getBundleGroupVirtualArticleDiscrepancies } from '../fn/bundle-groups/get-bundle-group-virtual-article-discrepancies';
import { GetBundleGroupVirtualArticleDiscrepancies$Params } from '../fn/bundle-groups/get-bundle-group-virtual-article-discrepancies';
import { getBundleGroupVirtualArticleDiscrepancy } from '../fn/bundle-groups/get-bundle-group-virtual-article-discrepancy';
import { GetBundleGroupVirtualArticleDiscrepancy$Params } from '../fn/bundle-groups/get-bundle-group-virtual-article-discrepancy';
import { getBundleGroupVirtualArticleNotes } from '../fn/bundle-groups/get-bundle-group-virtual-article-notes';
import { GetBundleGroupVirtualArticleNotes$Params } from '../fn/bundle-groups/get-bundle-group-virtual-article-notes';
import { getVirtualArticles } from '../fn/bundle-groups/get-virtual-articles';
import { GetVirtualArticles$Params } from '../fn/bundle-groups/get-virtual-articles';
import { patchBundleGroupVirtualArticleDiscrepancy } from '../fn/bundle-groups/patch-bundle-group-virtual-article-discrepancy';
import { PatchBundleGroupVirtualArticleDiscrepancy$Params } from '../fn/bundle-groups/patch-bundle-group-virtual-article-discrepancy';
import { removeBundleGroupVirtualArticle } from '../fn/bundle-groups/remove-bundle-group-virtual-article';
import { RemoveBundleGroupVirtualArticle$Params } from '../fn/bundle-groups/remove-bundle-group-virtual-article';
import { setBundleGroupVirtualArticleDiscrepancies } from '../fn/bundle-groups/set-bundle-group-virtual-article-discrepancies';
import { SetBundleGroupVirtualArticleDiscrepancies$Params } from '../fn/bundle-groups/set-bundle-group-virtual-article-discrepancies';
import { setBundleGroupVirtualArticleNoteVisible } from '../fn/bundle-groups/set-bundle-group-virtual-article-note-visible';
import { SetBundleGroupVirtualArticleNoteVisible$Params } from '../fn/bundle-groups/set-bundle-group-virtual-article-note-visible';
import { VirtualArticleDiscrepanciesResponse } from '../models/virtual-article-discrepancies-response';
import { VirtualArticleDiscrepancyResponse } from '../models/virtual-article-discrepancy-response';
import { VirtualArticleNoteResponse } from '../models/virtual-article-note-response';
import { VirtualArticleNotesResponse } from '../models/virtual-article-notes-response';

@Injectable({ providedIn: 'root' })
export class BundleGroupsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBundleGroups()` */
  static readonly GetBundleGroupsPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups';

  /**
   * List bundle groups of an organization site.
   *
   * Return the bundle groups (Mappengruppen) of a consignee organization
   * site with Basic-v3 style pagination, sorting and partial-match
   * filtering.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBundleGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroups$Response(params: GetBundleGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroupsArrayResponseV3>> {
    const obs = getBundleGroups(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List bundle groups of an organization site.
   *
   * Return the bundle groups (Mappengruppen) of a consignee organization
   * site with Basic-v3 style pagination, sorting and partial-match
   * filtering.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBundleGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroups(params: GetBundleGroups$Params, context?: HttpContext): Observable<BundleGroupsArrayResponseV3> {
    const resp = this.getBundleGroups$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BundleGroupsArrayResponseV3>): BundleGroupsArrayResponseV3 => r.body)
    );
  }

  /** Path part for operation `createBundleGroup()` */
  static readonly CreateBundleGroupPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups';

  /**
   * Create a bundle group (Mappengruppe).
   *
   * Create a new bundle group for a consignee organization site.
   *
   * A bundle group is always supply-chain based: the delivery notes are
   * grouped along the supply chain of the given `bundleKeys` (which must
   * share the same consignor + carrier + consignee). The group name is
   * generated by the backend (analog to the Basic Mappenname).
   *
   * Only organization sites with the `bundleGrouping` feature enabled may
   * use this endpoint.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBundleGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBundleGroup$Response(params: CreateBundleGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroup>> {
    const obs = createBundleGroup(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a bundle group (Mappengruppe).
   *
   * Create a new bundle group for a consignee organization site.
   *
   * A bundle group is always supply-chain based: the delivery notes are
   * grouped along the supply chain of the given `bundleKeys` (which must
   * share the same consignor + carrier + consignee). The group name is
   * generated by the backend (analog to the Basic Mappenname).
   *
   * Only organization sites with the `bundleGrouping` feature enabled may
   * use this endpoint.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBundleGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBundleGroup(params: CreateBundleGroup$Params, context?: HttpContext): Observable<BundleGroup> {
    const resp = this.createBundleGroup$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BundleGroup>): BundleGroup => r.body)
    );
  }

  /** Path part for operation `getBundleGroup()` */
  static readonly GetBundleGroupPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}';

  /**
   * Get a single bundle group.
   *
   * Return a single bundle group (Mappengruppe) of a consignee organization site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBundleGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroup$Response(params: GetBundleGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroup>> {
    const obs = getBundleGroup(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a single bundle group.
   *
   * Return a single bundle group (Mappengruppe) of a consignee organization site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBundleGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroup(params: GetBundleGroup$Params, context?: HttpContext): Observable<BundleGroup> {
    const resp = this.getBundleGroup$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BundleGroup>): BundleGroup => r.body)
    );
  }

  /** Path part for operation `deleteBundleGroup()` */
  static readonly DeleteBundleGroupPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}';

  /**
   * Delete (dissolve) a bundle group.
   *
   * Dissolve a bundle group (Mappengruppe) of a consignee organization site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBundleGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBundleGroup$Response(params: DeleteBundleGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteBundleGroup(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete (dissolve) a bundle group.
   *
   * Dissolve a bundle group (Mappengruppe) of a consignee organization site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBundleGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBundleGroup(params: DeleteBundleGroup$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteBundleGroup$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getVirtualArticles()` */
  static readonly GetVirtualArticlesPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles';

  /**
   * Get the Gesamtliste (virtual articles) of a bundle group.
   *
   * Return the persisted virtual articles (Gesamtliste) of a bundle group
   * (Mappengruppe) of a consignee organization site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVirtualArticles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVirtualArticles$Response(params: GetVirtualArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrichedVirtualArticle>>> {
    const obs = getVirtualArticles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the Gesamtliste (virtual articles) of a bundle group.
   *
   * Return the persisted virtual articles (Gesamtliste) of a bundle group
   * (Mappengruppe) of a consignee organization site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVirtualArticles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVirtualArticles(params: GetVirtualArticles$Params, context?: HttpContext): Observable<Array<EnrichedVirtualArticle>> {
    const resp = this.getVirtualArticles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<EnrichedVirtualArticle>>): Array<EnrichedVirtualArticle> => r.body)
    );
  }

  /** Path part for operation `removeBundleGroupVirtualArticle()` */
  static readonly RemoveBundleGroupVirtualArticlePath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/edit';

  /**
   * Remove a virtual article position as an edit.
   *
   * Mark a Gesamtliste position (Mappengruppe) as removed, analog to the
   * normal article remove (`editArticleRemove`). The position stays
   * readable but is marked `editedRemoved` and is skipped for
   * redistribution and discrepancy distribution at checkin finish. This is
   * the dedicated remove endpoint — the immutable snapshot is untouched.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeBundleGroupVirtualArticle()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeBundleGroupVirtualArticle$Response(params: RemoveBundleGroupVirtualArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = removeBundleGroupVirtualArticle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Remove a virtual article position as an edit.
   *
   * Mark a Gesamtliste position (Mappengruppe) as removed, analog to the
   * normal article remove (`editArticleRemove`). The position stays
   * readable but is marked `editedRemoved` and is skipped for
   * redistribution and discrepancy distribution at checkin finish. This is
   * the dedicated remove endpoint — the immutable snapshot is untouched.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeBundleGroupVirtualArticle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeBundleGroupVirtualArticle(params: RemoveBundleGroupVirtualArticle$Params, context?: HttpContext): Observable<void> {
    const resp = this.removeBundleGroupVirtualArticle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `editBundleGroupVirtualArticleAttributes()` */
  static readonly EditBundleGroupVirtualArticleAttributesPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/edit';

  /**
   * Edit partially the attributes of a virtual article position.
   *
   * Edit partially the attributes of a single Gesamtliste position
   * (Mappengruppe), analog to the normal article edit
   * (`/consignee/articles/{articleKey}/edit`): every editable article
   * attribute (e.g. gtin, pos, description, quantity) may be edited and is
   * stored non-destructively in the position's `edits` object — the
   * immutable snapshot is left untouched. The edited `quantity` is the
   * redistribution target applied at checkin finish. This is the dedicated
   * edit endpoint — edits are no longer sent at finish.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `editBundleGroupVirtualArticleAttributes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editBundleGroupVirtualArticleAttributes$Response(params: EditBundleGroupVirtualArticleAttributes$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrichedVirtualArticle>> {
    const obs = editBundleGroupVirtualArticleAttributes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Edit partially the attributes of a virtual article position.
   *
   * Edit partially the attributes of a single Gesamtliste position
   * (Mappengruppe), analog to the normal article edit
   * (`/consignee/articles/{articleKey}/edit`): every editable article
   * attribute (e.g. gtin, pos, description, quantity) may be edited and is
   * stored non-destructively in the position's `edits` object — the
   * immutable snapshot is left untouched. The edited `quantity` is the
   * redistribution target applied at checkin finish. This is the dedicated
   * edit endpoint — edits are no longer sent at finish.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `editBundleGroupVirtualArticleAttributes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  editBundleGroupVirtualArticleAttributes(params: EditBundleGroupVirtualArticleAttributes$Params, context?: HttpContext): Observable<EnrichedVirtualArticle> {
    const resp = this.editBundleGroupVirtualArticleAttributes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EnrichedVirtualArticle>): EnrichedVirtualArticle => r.body)
    );
  }

  /** Path part for operation `getBundleGroupVirtualArticleDiscrepancies()` */
  static readonly GetBundleGroupVirtualArticleDiscrepanciesPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/discrepancies';

  /**
   * Get all discrepancies of a virtual article position.
   *
   * Get all group-level discrepancies of a Gesamtliste position
   * (Mappengruppe), analog to `getArticleDiscrepanciesForArticle`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBundleGroupVirtualArticleDiscrepancies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroupVirtualArticleDiscrepancies$Response(params: GetBundleGroupVirtualArticleDiscrepancies$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleDiscrepanciesResponse>> {
    const obs = getBundleGroupVirtualArticleDiscrepancies(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all discrepancies of a virtual article position.
   *
   * Get all group-level discrepancies of a Gesamtliste position
   * (Mappengruppe), analog to `getArticleDiscrepanciesForArticle`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBundleGroupVirtualArticleDiscrepancies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroupVirtualArticleDiscrepancies(params: GetBundleGroupVirtualArticleDiscrepancies$Params, context?: HttpContext): Observable<VirtualArticleDiscrepanciesResponse> {
    const resp = this.getBundleGroupVirtualArticleDiscrepancies$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VirtualArticleDiscrepanciesResponse>): VirtualArticleDiscrepanciesResponse => r.body)
    );
  }

  /** Path part for operation `setBundleGroupVirtualArticleDiscrepancies()` */
  static readonly SetBundleGroupVirtualArticleDiscrepanciesPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/discrepancies';

  /**
   * Replace all discrepancies of a virtual article position.
   *
   * Replace all group-level discrepancies of a single Gesamtliste position
   * (Mappengruppe), analog to the normal article discrepancies endpoint
   * (`putConsigneeArticleDiscrepancies`). The discrepancies are
   * distributed back onto the source delivery notes at checkin finish.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setBundleGroupVirtualArticleDiscrepancies()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setBundleGroupVirtualArticleDiscrepancies$Response(params: SetBundleGroupVirtualArticleDiscrepancies$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleDiscrepanciesResponse>> {
    const obs = setBundleGroupVirtualArticleDiscrepancies(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Replace all discrepancies of a virtual article position.
   *
   * Replace all group-level discrepancies of a single Gesamtliste position
   * (Mappengruppe), analog to the normal article discrepancies endpoint
   * (`putConsigneeArticleDiscrepancies`). The discrepancies are
   * distributed back onto the source delivery notes at checkin finish.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setBundleGroupVirtualArticleDiscrepancies$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  setBundleGroupVirtualArticleDiscrepancies(params: SetBundleGroupVirtualArticleDiscrepancies$Params, context?: HttpContext): Observable<VirtualArticleDiscrepanciesResponse> {
    const resp = this.setBundleGroupVirtualArticleDiscrepancies$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VirtualArticleDiscrepanciesResponse>): VirtualArticleDiscrepanciesResponse => r.body)
    );
  }

  /** Path part for operation `addBundleGroupVirtualArticleDiscrepancy()` */
  static readonly AddBundleGroupVirtualArticleDiscrepancyPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/discrepancies';

  /**
   * Add a single discrepancy to a virtual article position.
   *
   * Add one group-level discrepancy to a Gesamtliste position
   * (Mappengruppe), analog to `postNewArticleDiscrepancy`. Distributed
   * onto the source delivery notes at checkin finish.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addBundleGroupVirtualArticleDiscrepancy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addBundleGroupVirtualArticleDiscrepancy$Response(params: AddBundleGroupVirtualArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleDiscrepancyResponse>> {
    const obs = addBundleGroupVirtualArticleDiscrepancy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a single discrepancy to a virtual article position.
   *
   * Add one group-level discrepancy to a Gesamtliste position
   * (Mappengruppe), analog to `postNewArticleDiscrepancy`. Distributed
   * onto the source delivery notes at checkin finish.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addBundleGroupVirtualArticleDiscrepancy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addBundleGroupVirtualArticleDiscrepancy(params: AddBundleGroupVirtualArticleDiscrepancy$Params, context?: HttpContext): Observable<VirtualArticleDiscrepancyResponse> {
    const resp = this.addBundleGroupVirtualArticleDiscrepancy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VirtualArticleDiscrepancyResponse>): VirtualArticleDiscrepancyResponse => r.body)
    );
  }

  /** Path part for operation `getBundleGroupVirtualArticleDiscrepancy()` */
  static readonly GetBundleGroupVirtualArticleDiscrepancyPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/discrepancies/{discrepancyKey}';

  /**
   * Get a single discrepancy of a virtual article position.
   *
   * Get one group-level discrepancy of a Gesamtliste position
   * (Mappengruppe) by key, analog to `getArticleDiscrepancy`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBundleGroupVirtualArticleDiscrepancy()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroupVirtualArticleDiscrepancy$Response(params: GetBundleGroupVirtualArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleDiscrepancyResponse>> {
    const obs = getBundleGroupVirtualArticleDiscrepancy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a single discrepancy of a virtual article position.
   *
   * Get one group-level discrepancy of a Gesamtliste position
   * (Mappengruppe) by key, analog to `getArticleDiscrepancy`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBundleGroupVirtualArticleDiscrepancy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroupVirtualArticleDiscrepancy(params: GetBundleGroupVirtualArticleDiscrepancy$Params, context?: HttpContext): Observable<VirtualArticleDiscrepancyResponse> {
    const resp = this.getBundleGroupVirtualArticleDiscrepancy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VirtualArticleDiscrepancyResponse>): VirtualArticleDiscrepancyResponse => r.body)
    );
  }

  /** Path part for operation `deleteBundleGroupVirtualArticleDiscrepancy()` */
  static readonly DeleteBundleGroupVirtualArticleDiscrepancyPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/discrepancies/{discrepancyKey}';

  /**
   * Delete a single discrepancy of a virtual article position.
   *
   * Delete one group-level discrepancy of a Gesamtliste position
   * (Mappengruppe) by key, analog to `deleteArticleDiscrepancy`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBundleGroupVirtualArticleDiscrepancy()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBundleGroupVirtualArticleDiscrepancy$Response(params: DeleteBundleGroupVirtualArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteBundleGroupVirtualArticleDiscrepancy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single discrepancy of a virtual article position.
   *
   * Delete one group-level discrepancy of a Gesamtliste position
   * (Mappengruppe) by key, analog to `deleteArticleDiscrepancy`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBundleGroupVirtualArticleDiscrepancy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBundleGroupVirtualArticleDiscrepancy(params: DeleteBundleGroupVirtualArticleDiscrepancy$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteBundleGroupVirtualArticleDiscrepancy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchBundleGroupVirtualArticleDiscrepancy()` */
  static readonly PatchBundleGroupVirtualArticleDiscrepancyPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/discrepancies/{discrepancyKey}';

  /**
   * Update a single discrepancy of a virtual article position.
   *
   * Update one group-level discrepancy of a Gesamtliste position
   * (Mappengruppe) by key, analog to `patchArticleDiscrepancy`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchBundleGroupVirtualArticleDiscrepancy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchBundleGroupVirtualArticleDiscrepancy$Response(params: PatchBundleGroupVirtualArticleDiscrepancy$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleDiscrepancyResponse>> {
    const obs = patchBundleGroupVirtualArticleDiscrepancy(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single discrepancy of a virtual article position.
   *
   * Update one group-level discrepancy of a Gesamtliste position
   * (Mappengruppe) by key, analog to `patchArticleDiscrepancy`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchBundleGroupVirtualArticleDiscrepancy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchBundleGroupVirtualArticleDiscrepancy(params: PatchBundleGroupVirtualArticleDiscrepancy$Params, context?: HttpContext): Observable<VirtualArticleDiscrepancyResponse> {
    const resp = this.patchBundleGroupVirtualArticleDiscrepancy$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VirtualArticleDiscrepancyResponse>): VirtualArticleDiscrepancyResponse => r.body)
    );
  }

  /** Path part for operation `addBundleGroupVirtualArticle()` */
  static readonly AddBundleGroupVirtualArticlePath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/edit';

  /**
   * Add a new virtual article position as an edit.
   *
   * Add a new consignee-created Gesamtliste position to a bundle group
   * (Mappengruppe), analog to the normal article add
   * (`editArticleAdd`). The position is marked `editedAdded`, is
   * non-summed and carries no source articles. Every editable article
   * attribute may be supplied (same set as the normal article add,
   * `ArticleAttributes`) and is stored on the position itself. This is the
   * dedicated add endpoint — the immutable snapshot is left untouched.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addBundleGroupVirtualArticle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addBundleGroupVirtualArticle$Response(params: AddBundleGroupVirtualArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrichedVirtualArticle>> {
    const obs = addBundleGroupVirtualArticle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a new virtual article position as an edit.
   *
   * Add a new consignee-created Gesamtliste position to a bundle group
   * (Mappengruppe), analog to the normal article add
   * (`editArticleAdd`). The position is marked `editedAdded`, is
   * non-summed and carries no source articles. Every editable article
   * attribute may be supplied (same set as the normal article add,
   * `ArticleAttributes`) and is stored on the position itself. This is the
   * dedicated add endpoint — the immutable snapshot is left untouched.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addBundleGroupVirtualArticle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addBundleGroupVirtualArticle(params: AddBundleGroupVirtualArticle$Params, context?: HttpContext): Observable<EnrichedVirtualArticle> {
    const resp = this.addBundleGroupVirtualArticle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EnrichedVirtualArticle>): EnrichedVirtualArticle => r.body)
    );
  }

  /** Path part for operation `checkBundleGroupVirtualArticle()` */
  static readonly CheckBundleGroupVirtualArticlePath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/check';

  /**
   * Check or uncheck a virtual article position.
   *
   * Check or uncheck a single Gesamtliste position (Mappengruppe), analog
   * to the normal article check
   * (`/consignee/articles/{articleKey}/check`). Marks that the position
   * was successfully processed. The `checked` flag is persisted on the
   * position and returned with the enriched read shape.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkBundleGroupVirtualArticle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkBundleGroupVirtualArticle$Response(params: CheckBundleGroupVirtualArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrichedVirtualArticle>> {
    const obs = checkBundleGroupVirtualArticle(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Check or uncheck a virtual article position.
   *
   * Check or uncheck a single Gesamtliste position (Mappengruppe), analog
   * to the normal article check
   * (`/consignee/articles/{articleKey}/check`). Marks that the position
   * was successfully processed. The `checked` flag is persisted on the
   * position and returned with the enriched read shape.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkBundleGroupVirtualArticle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkBundleGroupVirtualArticle(params: CheckBundleGroupVirtualArticle$Params, context?: HttpContext): Observable<EnrichedVirtualArticle> {
    const resp = this.checkBundleGroupVirtualArticle$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EnrichedVirtualArticle>): EnrichedVirtualArticle => r.body)
    );
  }

  /** Path part for operation `getBundleGroupVirtualArticleNotes()` */
  static readonly GetBundleGroupVirtualArticleNotesPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/notes';

  /**
   * Get all notes of a virtual article position.
   *
   * Get all notes of a single Gesamtliste position (Mappengruppe), analog
   * to `getArticleNotes`. Only notes written by the requesting site or
   * shared (noteVisibleForOthers) are returned, newest first.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBundleGroupVirtualArticleNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroupVirtualArticleNotes$Response(params: GetBundleGroupVirtualArticleNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleNotesResponse>> {
    const obs = getBundleGroupVirtualArticleNotes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all notes of a virtual article position.
   *
   * Get all notes of a single Gesamtliste position (Mappengruppe), analog
   * to `getArticleNotes`. Only notes written by the requesting site or
   * shared (noteVisibleForOthers) are returned, newest first.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBundleGroupVirtualArticleNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBundleGroupVirtualArticleNotes(params: GetBundleGroupVirtualArticleNotes$Params, context?: HttpContext): Observable<VirtualArticleNotesResponse> {
    const resp = this.getBundleGroupVirtualArticleNotes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VirtualArticleNotesResponse>): VirtualArticleNotesResponse => r.body)
    );
  }

  /** Path part for operation `addBundleGroupVirtualArticleNote()` */
  static readonly AddBundleGroupVirtualArticleNotePath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/notes';

  /**
   * Add a note to a virtual article position.
   *
   * Add one note to a single Gesamtliste position (Mappengruppe), analog
   * to the consignee article note (`postConsigneeArticleNote`). The note
   * carries the free text plus the consignee's visibility choice and is
   * persisted on the position with its own addressable `_key`.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addBundleGroupVirtualArticleNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addBundleGroupVirtualArticleNote$Response(params: AddBundleGroupVirtualArticleNote$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleNoteResponse>> {
    const obs = addBundleGroupVirtualArticleNote(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add a note to a virtual article position.
   *
   * Add one note to a single Gesamtliste position (Mappengruppe), analog
   * to the consignee article note (`postConsigneeArticleNote`). The note
   * carries the free text plus the consignee's visibility choice and is
   * persisted on the position with its own addressable `_key`.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addBundleGroupVirtualArticleNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addBundleGroupVirtualArticleNote(params: AddBundleGroupVirtualArticleNote$Params, context?: HttpContext): Observable<VirtualArticleNoteResponse> {
    const resp = this.addBundleGroupVirtualArticleNote$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VirtualArticleNoteResponse>): VirtualArticleNoteResponse => r.body)
    );
  }

  /** Path part for operation `setBundleGroupVirtualArticleNoteVisible()` */
  static readonly SetBundleGroupVirtualArticleNoteVisiblePath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/notes/{virtualArticleNoteKey}/visible';

  /**
   * Make a note of a virtual article position visible to others.
   *
   * Set one note of a Gesamtliste position (Mappengruppe) from not-visible
   * to visible, analog to `postConsigneeArticleNoteVisible`. One-way only:
   * a note can only be switched from not-visible to visible, never back.
   * Only the authoring site may publish its own note.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setBundleGroupVirtualArticleNoteVisible()` instead.
   *
   * This method doesn't expect any request body.
   */
  setBundleGroupVirtualArticleNoteVisible$Response(params: SetBundleGroupVirtualArticleNoteVisible$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = setBundleGroupVirtualArticleNoteVisible(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Make a note of a virtual article position visible to others.
   *
   * Set one note of a Gesamtliste position (Mappengruppe) from not-visible
   * to visible, analog to `postConsigneeArticleNoteVisible`. One-way only:
   * a note can only be switched from not-visible to visible, never back.
   * Only the authoring site may publish its own note.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setBundleGroupVirtualArticleNoteVisible$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setBundleGroupVirtualArticleNoteVisible(params: SetBundleGroupVirtualArticleNoteVisible$Params, context?: HttpContext): Observable<void> {
    const resp = this.setBundleGroupVirtualArticleNoteVisible$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `checkinBundleGroup()` */
  static readonly CheckinBundleGroupPath = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/checkin';

  /**
   * Start the checkin of a bundle group.
   *
   * Start the checkin for all delivery notes of a bundle group
   * (Mappengruppe). Guards against delivery notes that are already part of
   * an active checkin (N1) and returns 409 with the conflicting keys.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkinBundleGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkinBundleGroup$Response(params: CheckinBundleGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroupCheckinStartResponse>> {
    const obs = checkinBundleGroup(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Start the checkin of a bundle group.
   *
   * Start the checkin for all delivery notes of a bundle group
   * (Mappengruppe). Guards against delivery notes that are already part of
   * an active checkin (N1) and returns 409 with the conflicting keys.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkinBundleGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  checkinBundleGroup(params: CheckinBundleGroup$Params, context?: HttpContext): Observable<BundleGroupCheckinStartResponse> {
    const resp = this.checkinBundleGroup$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BundleGroupCheckinStartResponse>): BundleGroupCheckinStartResponse => r.body)
    );
  }

  /** Path part for operation `finishBundleGroupCheckin()` */
  static readonly FinishBundleGroupCheckinPath = '/organization-sites/{organizationSiteKey}/consignee/checkins/{checkinKey}/bundle-group/finish';

  /**
   * Finish the checkin of a bundle group.
   *
   * Finish the checkin of a bundle group (Mappengruppe). The group is
   * resolved from the Basic `checkinKey` in the path (equivalent to the
   * Basic finish path). Computes the back-distribution from the immutable
   * virtual-article snapshot, writes the Basic discrepancies/load-carriers
   * (replace-all) and finalizes the Basic checkin with the signatures,
   * then persists an immutable audit document (concept 4.5a) and marks the
   * group as checked in.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `finishBundleGroupCheckin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  finishBundleGroupCheckin$Response(params: FinishBundleGroupCheckin$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroupCheckinFinishResponse>> {
    const obs = finishBundleGroupCheckin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Finish the checkin of a bundle group.
   *
   * Finish the checkin of a bundle group (Mappengruppe). The group is
   * resolved from the Basic `checkinKey` in the path (equivalent to the
   * Basic finish path). Computes the back-distribution from the immutable
   * virtual-article snapshot, writes the Basic discrepancies/load-carriers
   * (replace-all) and finalizes the Basic checkin with the signatures,
   * then persists an immutable audit document (concept 4.5a) and marks the
   * group as checked in.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `finishBundleGroupCheckin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  finishBundleGroupCheckin(params: FinishBundleGroupCheckin$Params, context?: HttpContext): Observable<BundleGroupCheckinFinishResponse> {
    const resp = this.finishBundleGroupCheckin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BundleGroupCheckinFinishResponse>): BundleGroupCheckinFinishResponse => r.body)
    );
  }

}
